import { render, staticRenderFns } from "./PortalSitecore.vue?vue&type=template&id=3d7df73e"
import script from "./PortalSitecore.vue?vue&type=script&lang=js"
export * from "./PortalSitecore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports